import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCamera = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16779 5.4453C9.35325 5.1671 9.66548 5 9.99984 5H13.9998C14.3342 5 14.6464 5.1671 14.8319 5.4453L15.8684 7H17.9998C19.2885 7 20.3332 8.04467 20.3332 9.33333V16.6667C20.3332 17.9553 19.2885 19 17.9998 19H5.99984C4.71117 19 3.6665 17.9553 3.6665 16.6667V9.33333C3.6665 8.04467 4.71117 7 5.99984 7H8.13132L9.16779 5.4453ZM10.535 7L9.49855 8.5547C9.31309 8.8329 9.00086 9 8.6665 9H5.99984C5.81574 9 5.6665 9.14924 5.6665 9.33333V16.6667C5.6665 16.8508 5.81574 17 5.99984 17H17.9998C18.1839 17 18.3332 16.8508 18.3332 16.6667V9.33333C18.3332 9.14924 18.1839 9 17.9998 9H15.3332C14.9988 9 14.6866 8.8329 14.5011 8.5547L13.4647 7H10.535ZM11.9998 11C11.0794 11 10.3332 11.7462 10.3332 12.6667C10.3332 13.5871 11.0794 14.3333 11.9998 14.3333C12.9203 14.3333 13.6665 13.5871 13.6665 12.6667C13.6665 11.7462 12.9203 11 11.9998 11ZM8.33317 12.6667C8.33317 10.6416 9.97479 9 11.9998 9C14.0249 9 15.6665 10.6416 15.6665 12.6667C15.6665 14.6917 14.0249 16.3333 11.9998 16.3333C9.97479 16.3333 8.33317 14.6917 8.33317 12.6667Z"
        />
      </svg>
    );
  }
);
